import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import App from './App'
import {AuthProvider} from "./lib/auth.ts";
import {Provider as ThemeProvider} from '@memaro/themes';
import {Provider as FeedbackProvider} from "@memaro/feedback";
import awsRum from "./lib/awsrum.ts";
import "./lib/dayjs.ts"

const recordError = (...args: unknown[]) => {
    console.error(...args)
    awsRum.recordError(args[0])
}

const root = createRoot(document.getElementById('root')!, {
    onCaughtError: recordError,
    onUncaughtError: recordError,
    onRecoverableError: recordError,
})

root.render(
    <StrictMode>
        <AuthProvider>
            <ThemeProvider>
                <FeedbackProvider>
                    <App/>
                </FeedbackProvider>
            </ThemeProvider>
        </AuthProvider>
    </StrictMode>,
)
